<div class="detail__main">
  <kpd-collapse-panel
    [title]="application.name"
    [collapsed]="false"
    *ngIf="application.roles.length > 0"
    class="user-permissions__app"
  >
    <kpd-collapse-panel
      *ngFor="let role of application.roles"
      [title]="role.role"
      [collapsed]="true"
      class="user-permissions__role"
      (collapsedChange)="onRoleCollapseChange($event, role)"
      [loading]="role.loading"
    >
      <kpd-collapse-panel
        *ngFor="let permissionSet of role.permissionSets"
        [title]="permissionSet.name"
        [collapsed]="true"
        class="user-permissions__sets"
        (collapsedChange)="onPermissionSetCollapseChange($event, permissionSet)"
        [loading]="permissionSet.loading"
      >
        <ng-template kpdTemplate="headerExtra">
          <span
            class="state-tag"
            [ngClass]="{ 'state-tag--disabled': permissionSet.type !== 'assign' && permissionSet.type !== 'both' }"
            translate
            >Assign</span
          >
          <span
            class="state-tag"
            [ngClass]="{ 'state-tag--disabled': permissionSet.type !== 'use' && permissionSet.type !== 'both' }"
            translate
            >Use</span
          >
        </ng-template>
        <div *ngIf="!role.permissionSets || role.permissionSets.length === 0" class="user-permissions__no-permission">
          <clr-icon shape="info" class="user-permissions__icon"></clr-icon>
          {{ noPermissionSets }}
        </div>
        <div
          *ngIf="!permissionSet.permissions || permissionSet.permissions.length === 0"
          class="user-permissions__permission user-permissions__permission--info"
        >
          <clr-icon shape="info" class="user-permissions__icon"></clr-icon>
          {{ noPermissions }}
        </div>

        <div *ngFor="let permission of permissionSet.permissions" class="user-permissions__permission">
          {{ permission.name }}
          <span
            class="state-tag state-tag--deprecated"
            [attr.title]="permission.deprecatedMessage || 'Deprecated'"
            *ngIf="permission.isDeprecated"
            translate
            >Deprecated</span
          >
        </div>
      </kpd-collapse-panel>
    </kpd-collapse-panel>
  </kpd-collapse-panel>
</div>
